module.exports = __webpack_public_path__ + "static/img/main3.e1b646c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/main3.png
// module id = nsO+
// module chunks = 1